<template>
  <v-main class="fill-height" style="position: absolute">
    <v-card v-if="articles.length === 0 || errorCode === 500" width="280" class="ml-1" @click="$emit('closeWindow')">
      <v-alert v-model="alert" dismissible color="blue darken-2" border="left" elevation="2" colored-border
        icon="mdi-triangle">
        <strong>No</strong> post as yet.
      </v-alert>
    </v-card>
    <!--Desktop postPing vue-->
    <v-card color="transparent" class="ml-5 rounded-4 desktopPostPingContainer" :width="postPingWidth" max-height="78%" max-width="100vw"
      v-if="articles.length !== 0 && errorCode !== 500 && $vuetify.breakpoint.mdAndUp">
      <v-card v-for="article in sortedArticles" :key="article.id">
        <PostDetails v-model="cycle" :article="article" :countryName="countryName" @trigger-refresh-posts="handleTriggerRefreshPosts" @trigger-close-window="handleCloseWindow"/>
      </v-card>
      <!--
        <v-carousel :continuous="false" :cycle="cycle" :show-arrows="true" hide-delimiter-background hide-delimiters class="pa-0" :height="postPingHeight">
        </v-carousel> 
          -->
    </v-card>
    <!--Mobile postPing vue-->
    <v-card v-if="articles.length !== 0 && errorCode !== 500 && $vuetify.breakpoint.smAndDown"
      class="pt-1 mobilePostPingContainer" color="transparent"  min-width="postPingWidth" max-height="93%">
      <v-card color="transparent" v-for="article in sortedArticles" :key="article.id">
        <PostDetails v-model="cycle" :color="color" :article="article" :countryName="countryName" @trigger-refresh-posts="handleTriggerRefreshPosts" @trigger-close-window="handleCloseWindow"/>
      </v-card>
      <!--
        <v-carousel :continuous="false" :cycle="cycle" :show-arrows="true" hide-delimiter-background hide-delimiters class="pa-0 overflow-y: auto" :height="postPingHeight">
        </v-carousel>
      -->
    </v-card>
    <!--
    <v-card
      v-if="showNewsPage" 
      class="mx-auto pa-3 pt-0 news-page-overlay"
      :class="{'full-screen': fullScreen}"
    >
      <v-system-bar
        color="transparent"
      >
        <v-spacer></v-spacer>

        <v-icon class="mr-3" color="yellow">mdi-circle</v-icon>
        <v-icon class="mr-3" color="green" @click="toggleFullScreen">mdi-circle</v-icon>
        <v-icon color="red" @click="toggleNewsPageOverlay">mdi-circle</v-icon>
      </v-system-bar>
        <iframe 
          :src="articleAddress"
          width="100%"
          style="height: 96%;"
          frameborder="0"
          scrolling="yes"
        >
        </iframe>
    </v-card>
    -->
  </v-main>
</template>
<script>

import PostDetails from './postDetails.vue'

const moment = require('moment')
moment().format()
export default {
  data: () => ({
    // API_URL: apiUrl,
    opacity: 1,
    maximizeImage: false,
    alert: true,
    cycle: false,
    overlay: false,
    postProfileData: [''],
    profile_image: '',
    fab: "",
    onboarding: 0,
    showNewsPage: false,
    showProfilePage: false,
    dialog: false,
    imgDialog: false,

    // new like variables //
    liked: false,
    loading: false,
    // end of like variables //
    postLike: false,
    postReping: false,
    articleAddress: "",
    fullScreen: false,
    sheet: "",
  }),

  components: {
    // commentSection,
    // profilePage,
    // profilePost,
    // donationLink,
    //likeButton,
    PostDetails,
  },
  methods: {
    handleCloseWindow(){
      this.$emit('closeWindow')
    },
    handleTriggerRefreshPosts(){
      this.$emit('refresh-posts');
    },
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1
    },
   
    toggleFullScreen() {
      this.fullScreen = !this.fullScreen
    }
  },
  props: {
    //post: Object,
    articles: Array,
    countryName: String,
    countryCode: String,
    countryEmoji: String,
    donationLinkDialog: Boolean,
  },
  computed: {
    localCycle: {
      get() {
        return this.value; // reflect parent value
      },
      set(val) {
        this.$emit("input", val); // update parent, sync all
      }
    },
    sortedArticles() {
      return [...this.articles].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
    // Change height with different screen sizes
    postPingHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 550;
        case 'sm': return 550;
        case 'md': return 540;
        case 'lg': return 545;
        case 'xl': return 550;
        default: return 550; // Default value if no match
      }
    },
    postPingWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%';
        case 'sm': return '100%';
        case 'md': return 480;
        case 'lg': return 480;
        case 'xl': return 480;
        default: return 430; // Default value if no match
      }
    }
  },

  created() {
    this.getProfileData()
  },
}
</script>
<style>
.mobilePostPingContainer {
	position: fixed;
	background-color: transparent;
	height: 100%;
	overflow: auto;
  /* Fade at both top and bottom */
	-webkit-mask-image: linear-gradient(
		to bottom,
		transparent 0%,
		#000 1%,
		#000 95%,
		transparent 100%
	);
	mask-image: linear-gradient(
		to bottom,
		transparent 0%,
		#000 2%,
		#000 99%,
		transparent 100%
	);
}
.desktopPostPingContainer {
	position: fixed;
	background-color: transparent;
	height: 100%;
	overflow: auto;
  /* Fade at both top and bottom */
	-webkit-mask-image: linear-gradient(
		to bottom,
		transparent 0%,
		#000 1%,
		#000 95%,
		transparent 100%
	);
	mask-image: linear-gradient(
		to bottom,
		transparent 0%,
		#000 1%,
		#000 95%,
		transparent 100%
	);
}
</style>